/**
 * Sticky Aside
 * This script makes the order section 'sticky' - that is it will stay in the
 * window's view when scrolling to view the menu by adjusting the margin of
 * the element.
 */
import jQuery from 'jquery';
import _ from 'lodash';

const { browser } = Mobi2Go.UI;

Mobi2Go.UI.stickyAside = (function() {
    const $aside = jQuery('[data-sticky-aside]'); // Order
    const $content = jQuery('[data-sticky-content]'); // Menu
    const $window = jQuery(window);
    let aside_offset = 0;
    let aside_original_offset;
    let aside_max_offset;
    let aside_height;
    let content_height;
    let window_height;
    let previous_scroll; // used to determine scroll direction
    let margin;
    /*------------------------------
     * Some browsers are janky so use a different strategy to update
     * the position of the aside.
     */
    const should_animate =
        browser.ios || browser.android || browser.msie || browser.safari;

    Mobi2Go.Order.onReady(initiate);

    $window.resize(
        _.debounce(function() {
            window_height =
                $window.height() - Mobi2Go.UI.global_page_scroll_offset;
            updatePosition();
        }, 50)
    );

    function initiate() {
        window_height = $window.height() - Mobi2Go.UI.global_page_scroll_offset;
        margin = 18 + Mobi2Go.UI.global_page_scroll_offset;

        setOffset(0);

        _.delay(updateDimensions, 300);

        // Element heights may change - so continually check heights
        setInterval(updateDimensions, 800);

        // Different browsers behave differently so use different strategies
        // to update the position of the sticky when scrolling:
        bindUpdatePositionToScrollEvent();

        updateAsideOriginalOffset();
    }

    function bindUpdatePositionToScrollEvent() {
        $window.scroll(function() {
            window.requestAnimationFrame(updatePosition);
        });
    }

    function updateDimensions(force) {
        aside_height = $aside.height();
        content_height = $content.height();
        aside_max_offset = content_height - aside_height;
        updateAsideOriginalOffset();
        updatePosition(force);
    }

    let prev_scroll;
    function updatePosition(force) {
        const scroll = $window.scrollTop();
        let new_offset;
        const is_scrolling_down = scroll >= previous_scroll;

        if (scroll === prev_scroll && !force) {
            return;
        }

        prev_scroll = scroll;

        previous_scroll = scroll;
        new_offset = scroll - aside_original_offset + margin;

        if (aside_height > window_height) {
            const offset_top = aside_offset + aside_original_offset - margin;
            const offset_bottom = offset_top + aside_height + margin * 2;
            const viewport_top = scroll;
            const viewport_bottom = scroll + window_height;

            // If window viewport is 'between' the aside, lock offset
            // adjustment to allow free scrolling`
            if (
                viewport_top >= offset_top &&
                viewport_bottom <= offset_bottom
            ) {
                return;
            }

            // Lower range
            if (new_offset && is_scrolling_down) {
                new_offset -= aside_height + margin * 2 - window_height;
            }
        }

        // Do not exceed top or bottom
        if (new_offset > aside_max_offset) {
            new_offset = aside_max_offset;
        }
        if (new_offset < 0) {
            new_offset = 0;
        }

        setOffset(new_offset);
    }

    if (should_animate) {
        let timeout = 150;

        if (browser.ios && browser.chrome) {
            timeout = 50;
        } else if (browser.android) {
            timeout = 50;
        } else if (browser.msie) {
            timeout = 50;
        }
        updatePosition = _.debounce(updatePosition, timeout);
    }

    function setOffset(y) {
        let style;

        if (should_animate) {
            const transition = 'all .25s ease-out';
            style =
                `-webkit-transition: ${transition};` +
                `transition: ${transition};`;

            if (browser.ios || browser.android) {
                style +=
                    `-webkit-transform: translate3d(0,${y}px,0);` +
                    `transform: translate3d(0,${y}px,0);`;
            } else {
                style += `margin-top: ${y}px;`;
            }
        } else {
            style = `margin-top: ${y}px; `;
        }

        $aside.attr('style', style);

        aside_offset = y;

        if (aside_offset <= margin && !should_animate) {
            updateAsideOriginalOffset();
        }
    }

    function updateAsideOriginalOffset() {
        aside_original_offset = $aside.offset().top - aside_offset;
    }

    return {
        $aside,
        $content,
        setOffset,
        updateDimensions,
    };
})();
